document.addEventListener('DOMContentLoaded', function() {
    cDrawerTopTrigger();
    cSmoothScrollTrigger();
    cSlideMvTrigger();
    cBgNoiseTrigger();
    cImgModalTrigger();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
        cDrawerTopTrigger();
        cSmoothScrollTrigger();
        cSlideMvTrigger();
        cBgNoiseTrigger();
        cImgModalTrigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
        cDrawerTopTrigger();
        cSmoothScrollTrigger();
        cSlideMvTrigger();
        cBgNoiseTrigger();
        cImgModalTrigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
        cDrawerTopTrigger();
        cSmoothScrollTrigger();
        cSlideMvTrigger();
        cBgNoiseTrigger();
        cImgModalTrigger();
    });
}


/****************************************
     遅延関数のJS
****************************************/
function customDebounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}


/****************************************
     ドロワーの上部位置調整JS
****************************************/
function cDrawerTopTrigger() {
    if (document.querySelector('header-sidebar')) {
        cDrawerTop();
    }
};

function cDrawerTop() {
    const breakPoint = 700;
    
    function updateDrawerPosition() {
        const headerHeight = document.querySelector('.c-header').offsetHeight;
        const announcementBar = document.querySelector('.c-announcement-bar');
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const scrollTop = window.scrollY;
        
        const fixedPos = announcementBar 
            ? (scrollTop > announcementBarHeight ? headerHeight : headerHeight + (announcementBarHeight - scrollTop))
            : headerHeight;
        document.documentElement.style.setProperty('--custom-drawer-position', `${fixedPos}px`);
    }

    function checkBreakPoint() {
        const width = window.innerWidth;
        if (width < breakPoint) {
            updateDrawerPosition();
        }
    }

    checkBreakPoint();
    
    const debouncedUpdatePosition = customDebounce(updateDrawerPosition, 200);
    window.addEventListener('resize', debouncedUpdatePosition);

    const debouncedUpdateButtonPosition = customDebounce(updateDrawerPosition, 200);
    window.addEventListener('scroll', debouncedUpdateButtonPosition);
}


/****************************************
     メインビジュアルのスライダーJS
****************************************/
function cSlideMvTrigger() {
    if (document.querySelectorAll('.c-mv__section').length) {
        cSlideMv();
    }
};

function cSlideMv() {
    $('.c-mv__section').each(function() {
        const $section = $(this);
        const $slick = $(this).find('.c-mv__wrapper.slider');
        const $progressBarLabels = $(this).find('.c-progress__label');
        const $titleAnims = $(this).find('.c-title-anim');

        const slideAutoplay = $section.data('autoplay');
        const slideSpeed = $section.data('autoplaySpeed');
        const slideArrow = $section.data('arrow');

        $slick.not('.slick-initialized').slick({
            autoplay: slideAutoplay,
            autoplaySpeed: slideSpeed,
            arrows: slideArrow,
            // draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            pauseOnFocus: false,
            prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse"><span class="c-arrow__svg"></span></button>',
            nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal"><span class="c-arrow__svg"></span></button>',
            fade: true,
        });

        $progressBarLabels
          .css('transition', 'none')
          .css('width', 0);

        setTimeout(() => {
            $progressBarLabels
              .css('transition', `width ${slideSpeed}ms linear`)
              .css('width', 100 + '%');
        }, 20);

      $titleAnims.each(function() {
            const html = $(this).html();
            $(this).empty();
    
            const parts = html.split('<br>');
            parts.forEach((part, partIndex) => {
                if (partIndex > 0) {
                    const br = document.createElement('br');
                    $(this).append(br);
                }
                
                const spans = part.split('').map((char, index) => {
                    const span = document.createElement('span');
                    span.textContent = char;
                    span.style.animationDelay = `${(partIndex * 1 + index) * 0.05}s`;
                    return span;
                });
                
                $(this).append(spans);
            });
        });
    });
}


/****************************************
     フッター背景ノイズのJS
****************************************/
function cBgNoiseTrigger() {
    if (document.querySelectorAll('.c-footer__noise').length) {
        cBgNoise();
    }
};

function cBgNoise() {
    const body = document.querySelector('body');
  
    const BgNoise = {
      set() {
        const duration = Math.random() * (40 - 4) + 4;
        body.classList.toggle('is-noise');
        this.timer = setTimeout(() => {
          this.set();
        }, duration * 100);
      },
      init() {
        this.set();
      },
    };
    
    BgNoise.init();
}


/****************************************
     画像拡大表示のモダールJS
****************************************/
function cImgModalTrigger() {
    if (document.querySelectorAll('.c-img-modal__list').length) {
        cImgModal();
    }
};

function cImgModal() {
    const html = document.querySelector('html');
    const modal = document.querySelector('.c-img__modal');
    const modalImg = document.querySelector('.c-img__modal__img');
    const closeBtn = document.querySelector('.c-img__modal__close');

    document.querySelectorAll('.c-img-modal__list img').forEach(function(img) {
        img.onclick = function() {
            modalImg.src = this.src;
            modalImg.alt = this.alt;
            modal.classList.add('is-active');
            this.parentElement.setAttribute('aria-expanded', 'true');
            html.classList.add('lock');
        }
    });

    closeBtn.onclick = function() {
        modal.classList.remove('is-active');
        html.classList.remove('lock');
        document.querySelectorAll('.c-img-modal__list[aria-expanded="true"]').forEach(function(item) {
            item.setAttribute('aria-expanded', 'false');
        });
    }

    modal.onclick = function(e) {
        if (e.target === modal) {
            modal.classList.remove('is-active');
            html.classList.remove('lock');
            document.querySelectorAll('.c-img-modal__list[aria-expanded="true"]').forEach(function(item) {
              item.setAttribute('aria-expanded', 'false');
            });
        }
    }   
}


/****************************************
     トップへ戻るボタン
****************************************/
function cSmoothScrollTrigger() {
    if (document.querySelectorAll('.c-smoothscroll').length) {
        cSmoothScroll();
    }
};

function cSmoothScroll() {
    let viewOffset = 160;
    const smoothScrollEl = document.querySelector('.c-smoothscroll');

    if (smoothScrollEl.classList.contains('c-page-lp')) {
        function viewSmoothScroll() {
            if (window.pageYOffset > viewOffset) {
                smoothScrollEl.classList.add('c-view');
            } else {
                smoothScrollEl.classList.remove('c-view');
            }
        }
    
        function handleResize() {
            if (window.innerWidth <= 700) {
                smoothScrollEl.classList.remove('c-view');
                window.removeEventListener('scroll', viewSmoothScroll);
            } else {
                viewSmoothScroll();
                window.addEventListener('scroll', viewSmoothScroll);
            }
        }

        const debouncedHandleResize = customDebounce(handleResize, 200);
        window.addEventListener("resize", debouncedHandleResize, false);
        handleResize();
    }

    smoothScrollEl.addEventListener('click', function() {
        window.scroll({ top: 0, behavior: "smooth" });
    });
}


/****************************************
     ふわっと表示のJS
****************************************/
$(window).scroll(function (){
	$('.c-fadein').each(function(){
        const offsetNum = 150;
		const elemPos = $(this).offset().top,
		scroll = $(window).scrollTop(),
		windowHeight = $(window).height();

        if (scroll > elemPos - windowHeight + offsetNum){
            $(this).addClass('c-scrollin');

            if ($(this).hasClass('lp-titlebox')) {
                $(this).addClass('is-anim');
            }
        }
	});
});


/****************************************
     背景アニメーションのJS
****************************************/
$(window).scroll(function (){
	$('.c-bganim').each(function(){
        const offsetNum = 0;
		const elemPos = $(this).offset().top,
		scroll = $(window).scrollTop(),
		windowHeight = $(window).height();

        if (scroll > elemPos - windowHeight + offsetNum){
            $(this).addClass('is-anim');
        }
	});
});


/****************************************
     ドロワーメニューの開閉JS
****************************************/
$(document).ready(function() {
    $(document).on('click', '.c-toggle__title', function() {
        $(this).next('.c-toggle__content').slideToggle();
        $(this).toggleClass('is-active');
    });
});

/****************************************
    リダイレクトするため商品価格は遅延ロード
****************************************/
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      const block = document.querySelector('.product-info__block-item[data-block-id="price"]');
      if (block) {
        console.log(block);
        block.classList.add('show');
      } else {
        console.log('要素がありません');
      }
    }, 3000); // 3000ミリ秒 = 3秒
  });



// script for geolizr
//  document.addEventListener('geolizr.init', () => {
//     Geolizr.redirectFilter = function(redirect, urlObj) {
//       let isUs = redirect.countries.indexOf('US') > -1;
//       let isJp = redirect.countries.indexOf('JP') > -1;
//       let isExt = isUs === false && isJp === false;
      
//       const currentPath = location.pathname;

//       // 日本からのアクセスで/en-us/products/へのアクセス → /pages/notice-1 にリダイレクト
//       if (isJp && currentPath.includes('/en-us/products/')) {
//         urlObj.url = '/pages/notice-1';
//         return true;
//       }
      
//       // アメリカからのアクセスで/en-us/で始まらないパス → /en-us/ を付加
//       if (isUs && !currentPath.startsWith('/en-us/')) {
//         urlObj.url = '/en-us' + currentPath;
//         return true;
//       }

//       // その他の国からのアクセスのみ処理
//       if (isExt) {
//         // 特定のパスへのアクセスを処理
//         if (currentPath === '/' || currentPath === '/pages/smt-a1') {
//           urlObj.url = currentPath === '/' ? '/en-us' : '/en-us/pages/smt-a1';
//           return true;
//         }

//         // /products/へのアクセス → /en-us/pages/notice-2 にリダイレクト
//         if (currentPath.includes('/products/')) {
//           urlObj.url = '/en-us/pages/notice-2';
//           return true;
//         }

//         // その他のパスに/en-us/を付加（ただし、既に /en-us/ で始まるパスはリダイレクトしない）
//        if (!currentPath.startsWith('/en-us/')) {
//           // 既に/en-us/が含まれている場合は重複を防ぐ
//           const newPath = currentPath.startsWith('/en-us') ? currentPath : '/en-us' + currentPath;
//           // リダイレクト先が現在のパスと同じ場合はリダイレクトしない
//           if (newPath !== currentPath) {
//             urlObj.url = newPath;
//             return true;
//           }
//         }
//       }
      
//       return false;
//     }
//   });